import { Col, Form, FormInstance, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  QuestReportStockAbcCurveFormValues,
  StockAbcCurveOrderBy,
  StockAbcCurveReportType,
} from '@/core/domain/questReport/Reports/StockAbcCurve/StockAbcCurve.types';
import { FloatingFormItem } from '@/components/_common';
import GroupsInfiniteSelectField from '@/components/_common/GroupsInfiniteSelectField';
import { useEffect } from 'react';

interface Props {
  form: FormInstance<QuestReportStockAbcCurveFormValues>;
}

export default function ABCAnalysisForm({ form }: Props) {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;
  const { part, service, customer } = StockAbcCurveReportType;
  const { quantity, value: importanceValue } = StockAbcCurveOrderBy;

  const reportType = Form.useWatch('reportType', form);

  const reportTypeOptions = [
    {
      label: intl({ id: 'reportStock.ABCAnalysis.radio.part' }),
      value: part,
    },
    {
      label: intl({ id: 'reportStock.ABCAnalysis.radio.service' }),
      value: service,
    },
    {
      label: intl({ id: 'reportStock.ABCAnalysis.radio.customer' }),
      value: customer,
    },
  ];

  useEffect(() => {
    form.setFieldValue('groupIds', undefined);
  }, [reportType]);

  const reportImportanceOptions = [
    {
      label: intl({ id: 'reportStock.ABCAnalysis.radio.quantity' }),
      value: quantity,
    },
    {
      label: intl({ id: 'reportStock.ABCAnalysis.radio.value' }),
      value: importanceValue,
    },
  ];

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields form={form} />
      <Row gutter={[24, 12]}>
        <Col lg={24}>
          <Form.Item
            name="reportType"
            style={{ margin: '4px 0' }}
            label={
              <Title level={5} style={{ margin: '0' }}>
                {intl({ id: 'reportStock.ABCAnalysis.label.report' })}
              </Title>
            }
            initialValue={part}
          >
            <Radio.Group
              options={reportTypeOptions}
              buttonStyle="solid"
              optionType="button"
              size="large"
            />
          </Form.Item>
        </Col>

        <Col lg={24}>
          <Form.Item
            name="orderBy"
            style={{ margin: '4px 0' }}
            label={
              <Title level={5} style={{ margin: '0' }}>
                {intl({ id: 'reportStock.ABCAnalysis.label.importance' })}
              </Title>
            }
            initialValue={quantity}
          >
            <Radio.Group
              options={reportImportanceOptions}
              buttonStyle="solid"
              optionType="button"
              size="large"
            />
          </Form.Item>
        </Col>

        {reportType === StockAbcCurveReportType.part && (
          <Col span={24} lg={8}>
            <FloatingFormItem name="groupIds" label="Grupos">
              <GroupsInfiniteSelectField mode="multiple" onlyGroups />
            </FloatingFormItem>
          </Col>
        )}
      </Row>
    </Form>
  );
}
